<template>
  <div class="w-full max-w-md mx-auto">
    <form class="w-full" @submit.prevent="submit">
      <p
        class="text-center text-grey-7 mb-2"
      >Please press the button below to complete verification.</p>

      <div class="w-full text-center">
        <nx-button
          native-type="submit"
          type="success"
          :disabled="loading"
        >{{ loading ? 'Loading..' : 'Verify' }}</nx-button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "EmailVerifyForm",
  data() {
    return {
      loading: false,
      expires: this.$route.query.expires,
      signature: this.$route.query.signature,
      user: this.$route.params.username
    }
  },
  methods: {
    async submit() {
      this.loading = true
      await this.$api.auth
        .verifyEmail({
          user: this.user,
          expires: this.expires,
          signature: this.signature
        })
        .then(() => {
          this.$toasted.success("Verification successful. Welcome to the community!")
          this.$auth.fetch()
          this.$router.push({name: 'channels.index'})
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.$toasted.info("Your email has already been verified.")
            this.$auth.fetch()
            this.$router.push({name: 'channels.index'})
          } else if (data.response && data.response.status === 403) {
            this.$toasted.info("Link is either invalid or expired. Please request a new verification email.")
          }else {
            this.$error.generic()
          }
        })
      this.loading = false
    }
  }
}
</script>
